import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserService } from '../services/user/user.service';

/**
 * Guard that protects routes requiring a linked user account.
 * Redirects to /user/link if the user is not linked.
 * Allows access to /user/link route even if user is not linked.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const userLinkedGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  // In development mode, skip the check (similar to app.component)
  if (!environment.production) {
    return true;
  }

  // Check if user is linked by attempting to get current user
  return userService.getCurrentUser().pipe(
    map(() => {
      // User is linked, allow access
      return true;
    }),
    catchError(() => {
      // User is not linked, redirect to link page
      router.navigate(['/user/link']);
      return of(false);
    }),
  );
};
